import React from 'react';
import Link from 'gatsby-link';

import PageHeader from '../components/PageHeader';
import PostPreview from '../components/PostPreview';
import GoogleMap from '../components/GoogleMap';

import './styles/index.scss';

const IndexPage = ({ data, defaultPreview }) => {
  const { posts, markers } = data;

  const renderPostsPreviews = (posts) => {
    const rendered = posts.map(({ node }) => {
      const { banner } = node.frontmatter;

      const postPreview = (banner)
      ? banner.childImageSharp.sizes
      : defaultPreview.sizes;

      return (
        <PostPreview 
          key={node.id}
          data={node}
          image={postPreview}
          className="postPreview--thirdWidth"
        />
      );
    });

    return rendered;
  }

  return (
    <div className="main indexPage">
      <PageHeader title="Suivez les aventures de Big Boy !" />

      <div className="indexPage-intro">
        <p>
        Deux ans de PVT au Canada.  <br/>
        Big Boy, un van de 1985.  <br/>
        10 000 000 km² à découvrir.  <br/>
        Mais on va déjà commencer par les 5000km qui séparent Montréal de
        Vancouver.
        <br/> <br/>
        Suivez notre périple en ligne.
        </p>
      </div>
      <hr/>

      <div className="indexPage-postsPreviews">
        <div className="indexPage-postsPreviews-title">
          <h2>Les dernières nouvelles</h2>
        </div>
        <div className="indexPage-postsPreviews-list">
          { renderPostsPreviews(posts.edges) }
        </div>
        <div className="indexPage-postsPreviews-viewAll">
          <Link to="/posts">Voir tous les articles ></Link>
        </div>
      </div>

      <div className="indexPage-postsPreviews-googleMap">
        <h2>Les points de passage</h2>
    		<GoogleMap markers={markers.edges}/>
      </div>
    </div>
  );
};

export default IndexPage;

export const query = graphql`
  query indexPageQuery {
    posts: allMarkdownRemark(
        sort: {fields: [frontmatter___date], order: DESC},
        limit: 3,
        filter: {fileAbsolutePath: {regex: "/(posts)/.*\\.md$/"}, frontmatter: { published: {eq: "true"}}}
    ) {
      edges {
        node {
          id
          frontmatter {
            title
            date(formatString: "DD MMMM YYYY", locale: "fr")
            description
            banner {
              childImageSharp {
                sizes(maxWidth: 300, maxHeight: 200, cropFocus: CENTER) {
                  ...GatsbyImageSharpSizes
                }
              }
            } 
          }
          fields {
            slug
          }
        }
      }
    }
    markers: allMarkdownRemark(filter: {fileAbsolutePath: {regex: "/(markers)/.*\\.md$/"}}) {
      edges {
        node {
          frontmatter {
            title
            description
            latitude
            longitude
          }
          html
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.jsx